import { Component } from '@angular/core';
import { PaChipComponent } from 'src/app/shared/ui-kit/pa-chip/pa-chip.component';

@Component({
  selector: 'app-chip-view',
  standalone: true,
  imports: [PaChipComponent],
  templateUrl: './chip-view.component.html',
  styleUrls: ['./chip-view.component.scss'],
})
export class ChipViewComponent {
  onChipRemove(): void {
    console.log('Chip removed');
  }
}
